module.exports = __webpack_public_path__ + "static/img/rental.319e225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rental.png
// module id = RleS
// module chunks = 0